import { render, staticRenderFns } from "./Son.vue?vue&type=template&id=6477bb76&"
import script from "./Son.vue?vue&type=script&lang=js&"
export * from "./Son.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports